export default __webpack_public_path__ + "static/media/expl-nn_09_DE.7ed80887.png";